import { render, staticRenderFns } from "./SelectionProduct.vue?vue&type=template&id=04a550bf&scoped=true&lang=pug&"
import script from "./SelectionProduct.vue?vue&type=script&lang=js&"
export * from "./SelectionProduct.vue?vue&type=script&lang=js&"
import style0 from "./SelectionProduct.vue?vue&type=style&index=0&id=04a550bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a550bf",
  null
  
)

export default component.exports